<template>
	<BasicLayout :left="left" :middle="middle" :right="right">
		<template v-slot:right_view>
			<div class="h100-100">
				<div class="h-scroll h-wrapper-680">
					<div class="h-dialogContainer">
						<form id="thresholdConfigForm">
							<div class="row h-row-inputBox">
								<div class="form-group h-col-inputBox">
									<div class="e-float-input">
										<div class="h-inputLit">{{$t('System.CPUUsage')}}</div>
										<div class="e-input-group e-control-wrapper">
											<input :placeholder="$t('System.input1t100')" id="maxLayer" name="CPUUsage" v-model="cpuUsage" />
										</div>
									</div>
								</div>
								<div class="form-group h-col-inputBox">
									<div class="e-float-input">
										<div class="h-inputLit">{{$t('System.MemoryUsage')}}</div>
										<div class="e-input-group e-control-wrapper">
											<input :placeholder="$t('System.input1t100')" id="minLayer" name="MemoryUsage" v-model="memoryUsage" />
										</div>
									</div>
								</div>
								<div class="form-group h-col-inputBox">
									<div class="e-float-input">
										<div class="h-inputLit">{{$t('System.DiskUsage')}}</div>
										<div class="e-input-group e-control-wrapper">
											<input :placeholder="$t('System.input1t100')" id="defaultLayer" name="DiskUsage" v-model="diskUsage" />
										</div>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
        <div class="b-t"></div>
        <div class="h-scroll h-system-wrapper-680">
          <div class="h-bottom-btnBox h-system-btnBox">
            <div class="row">
              <div class="col-sm-12 h-col-inputBox">
                <!-- <ejs-button cssClass="e-control e-btn e-lib e-flat" @click.native="resetThreshold">{{$t('System.reset')}}</ejs-button> -->
                <ejs-button cssClass="e-control e-btn e-lib e-flat" @click.native="clearThreshold">{{$t('Alarm.clear')}}</ejs-button>
                <ejs-button cssClass="e-control e-btn e-lib e-primary e-flat" @click.native="saveThreshold">{{$t('System.save')}}</ejs-button>
              </div>
            </div>
          </div>
        </div>
			</div>
		</template>
	</BasicLayout>
</template>

<script>
import BasicLayout from "../../layouts/BasicLayout";
import mixin from '../../mixin/mixin';
import {EventBus} from "../../plugins/eventBus";
export default {
	name: 'Threshold',
	mixins: [mixin],
	components: {
		BasicLayout,
	},
	data() {
		return {
			left: { show: false, name: "" },
			middle: { show: false, name: "" },
			right: {
				show: true,
				crumb: `${this.$t('System.systemManager')}/${this.$t("System.systemSet")}/${this.$t("System.ThresholdConfig")}`
			},
			cpuUsage: 80,
			memoryUsage: '80',
			diskUsage: '80',
			formObj: '',
			inputNames: ['CPUUsage', 'MemoryUsage', 'DiskUsage'],
			rules: {
				CPUUsage: { required: true, number: true, range: [1, 100], regex: 'integer'},
				MemoryUsage: { required: true, number: true, range: [1, 100], regex: 'integer'},
				DiskUsage: { required: true, number: true, range: [1, 100], regex: 'integer'},
			}
		}
	},
	methods: {
	// async resetThreshold() {
    //   await this.getThreshold();
    //   Object.keys(this.rules).forEach((item) =>{
    //     let id = item+"-info";
    //     if(document.getElementById(id)){
    //       document.getElementById(id).style.display = "none" ;
    //     }
    //   })
    // },
		clearThreshold() {
			this.cpuUsage = '';
			this.memoryUsage = '';
			this.diskUsage = '';
		},
		saveThreshold() {
			const status = this.formObj.validate();
			if (!status) {
				return null;
			}
			const url = '/lte/ems/sysmanager/threshold/saveThreshold';
			const params = {
				cpuUsage: this.cpuUsage,
				memoryUsage: this.memoryUsage,
				diskUsage: this.diskUsage
			};
			this.axios.post(url, params).then(response => {
			if(response.data === undefined){
				return;
			}
			if(response.status === 200) {
			if (response.data.errorCode === 'SUCCESS') {
				EventBus.$emit('toast', {type: 'success', content: this.$t('System.saveMapSuccess')});
				This.devdata = response.data.resultVal.result;
				This.page.totalCount = response.data.resultVal.totalCount;
			} else {
				EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
				this.getThreshold();
			}
			}
		 });
		},
		getThreshold() {
			const url = '/lte/ems/sysmanager/threshold/queryThreshold';
			this.axios.get(url).then(response => {
				const result = response.data;
				this.cpuUsage = result['cpuUsage'],
				this.memoryUsage = result['memoryUsage'],
				this.diskUsage = result['diskUsage']
			});
        },
	},
	mounted() {
        this.formObj = this.validateForm('thresholdConfigForm', this.inputNames, this.rules);
		this.getThreshold();
	}
}
</script>

